import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ItiCodesService {
  OBPortalSvcURL = '';
  
constructor(
  private appConfigService: AppConfigService,
  private httpClient: HttpClient, 
) { }

public getItiCodes (evtCode: string | undefined): Observable<any> {
  this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
   const ItiCodesInfo: JSON = <JSON>(<unknown>{
    evtCode: evtCode,
   });
   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   return this.httpClient.post<any>(
     this.OBPortalSvcURL + 'GetItiCodes',
     JSON.stringify(ItiCodesInfo),
     { headers: headers }
   );
 }
}